import React, { Component } from "react";
import { connect } from "react-redux";

import { Container } from "./Container";
import { Sidebar, SwapForm, SimpleReport } from "../components";
import { Header, TabBar, CheckboxMolecule, TableMonthsOfYear } from "../molecules";
import { TextAreaInput } from "../atoms";

import { DashboardController } from "../controllers";
import { setAuthAction } from "../actions";

import {
	categoriesFormsModel,
	mensurationSteps,
	menagementSteps,
	comunicationsSteps,
	mensurationQuestions,
	mensurationValues
} from "../models";

class Dashboard extends Container {
	constructor(props) {
		super(props);
		this.state = {
			categorySelected: "",
			section: "",
			hiddenReport: true,
			subcategoryStep: "",
			steps: {},
			subcategories: { mensurationSteps, menagementSteps, comunicationSteps: comunicationsSteps },
			values: { 
				mensuration: mensurationValues,
				menagement: { governanceResponsibilities: {} }, 
				comunication: { engagement: {} } 
			},
			mensuration: { subcategorySelected: "waterTreatment" },
			menagement: { subcategorySelected: "governanceResponsibilities" }, 
			comunication: { subcategorySelected: "engagement" },
			loaded: false,
			modal: true
		};

		this.controller = new DashboardController(this);
		this.openModal = this.openModal.bind(this);
	}

	componentWillMount(){
		this.controller.init();
	}

	componentDidMount(prevProps, prevState){
		if(this.state.categorySelected) {
			setTimeout(() => this.controller.linkMenu({currentTarget: {id: "#"+this.state.categorySelected}}), 0);
		}
		const state = this.getState();
		$("ul.tabs").tabs();
		$(".collapsible").collapsible();
		$(".modal").modal();
		$("#reportModal").modal({
			complete: () => {
				state.hiddenReport = true; this.callback(state);
				this.props.router.push("/dashboard");
			}
		});
	}
	componentDidUpdate() {
		$('.collapsible').collapsible();
		if (this.state[this.state.categorySelected].subcategorySelected === "input" && this.state.modal) {
			$("#showInputModal").modal("open"); 
			this.setState({modal: false});
		}
		if(!this.state.hiddenReport) $("#reportModal").modal("open");
	}

	componentWillReceiveProps(nextProps){
		this.controller.init(nextProps);
	}

	openModal() {
		$(document).ready(function(){
	    $('#doneFormAction').modal();
	  });
	  return(
			null
  	);
	}
	
	render() {
		const state = this.getState();
		if(!this.state.categorySelected) return <img className="flex v c al-c" src={"https://s3-us-west-2.amazonaws.com/permuta-v2-images/Permuta-admin/rolling.svg"} />;

		const categorySelected = state.categorySelected;
		const subcategorySelected = state[categorySelected].subcategorySelected;
		return (
			<section className="main flex">
				<div className="content">
					<Header headerTitle="" />
					<div className="col s12">
						<TabBar selecteds={this.props.auth.done} clickAction={this.controller.changeCategory} id="primary" tabs={categoriesFormsModel}
						/>
					</div>
					<div className="col s12">
						<div id="comunication">
							<TabBar selected={subcategorySelected} clickAction={this.controller.changeSubcategory} id="secondary" tabs={comunicationsSteps}
							/>
						</div>
					</div>
					<div className="col s12">
						<div id="mensuration">
							<TabBar selected={subcategorySelected} clickAction={this.controller.changeSubcategory} id="secondary" tabs={mensurationSteps}
							/>
						</div>
					</div>
					<div className="col s12">
						<div id="menagement">
							<TabBar selected={subcategorySelected} clickAction={this.controller.changeSubcategory} id="secondary" tabs={menagementSteps}
							/>
						</div>
					</div>
					<div className="col s12">
						<SwapForm
							doneStepAction={this.controller.doneAction}
							handleChangeInputTextTable={this.controller.handleChangeInputTextTable}
							handleChangeInputTextDinamic={this.controller.handleChangeInputTextDinamic}
							handleChangeInputCheckbox={this.controller.handleChangeInputCheckbox}
							handleChangeInputLocation={this.controller.handleChangeInputLocation}
							handleChangeInputRadio={this.controller.handleChangeInputRadio}
							handleChangeInputRange={this.controller.handleChangeInputRange}
							handleChangeInputSpecialRange={this.controller.handleChangeInputSpecialRange}
							handleChangeInputRadioDinamic={this.controller.handleChangeInputRadioDinamic}
							handleChangeInputText={this.controller.handleChangeInputText}
							setDinamicValues={this.controller.setDinamicValues}
							changeAction={this.controller.changeAction}
							values={this.state.values[categorySelected][subcategorySelected]}
							subcategory={state.steps}
							finishStep={this.controller.nextSubcategory}
							nextStepAction={this.controller.selectFunctions()}
							prevStepAction={this.controller.prevSubcategory}
						/>
					</div>
				</div>
				<div id="showInputModal" className="modal">
					<div className="modal-content">
						<h4>Pegada Hídrica de Produtos</h4>
						<p className="contant-from-modal-done-form">
							Os dados coletados nesta etapa podem ser utilizados para cálculo da Pegada Hídrica, ou seja, o consumo de água na cadeia produtiva dos principais insumos da empresa. Com as informações sobre o tipo e a origem dos insumos, é possível estimar, com base em referências disponíveis, o consumo de água na produção destes.
						</p>
						<p className="contant-from-modal-done-form">
							O objetivo é identificar quais são os principais produtos e unidades operacionais da companhia que são dependentes indiretamente no consumo de água. Assim, é possível identificar potenciais riscos de escassez hídrica na cadeia produtiva.
						</p>
						<p className="contant-from-modal-done-form">
							A Consultoria H2O Company possui um banco de dados sobre Pegada Hídrica dos principais insumos para a realização destas estimativas. Entre em contato e solicite um orçamento para elaboração de Estudo de Pegada Hídrica para sua empresa.
						</p>
					</div>
					<div className="modal-footer">
						<a className="modal-action modal-close waves-effect waves-green btn-flat">CONFIRMA</a>
					</div>
				</div>
				<div id="doneFormAction" className="modal">
					<div className="modal-content">
						<h4>AVISO!</h4>
						<p className="contant-from-modal-done-form">Ao “Salvar e finalizar seção”, você não poderá retornar para ajustar as respostas das questões.</p>
					</div>
					<div className="modal-footer">
						<a href="#" onClick={() => this.controller.clickNextStep(this.state.categorySelected, this.props.auth)} className="modal-action modal-close waves-effect waves-green btn-flat">ACEITAR</a>
						<a href="#" className="modal-action modal-close waves-effect waves-green btn-flat">REJEITAR</a>
					</div>
				</div>
				<div id="reportModal" className="modal">
					<div className="modal-content">
						<h4>{this.state.reportGraphName}</h4>
						{this.state.hiddenReport || <SimpleReport noMask={true} label={""} items={this.state.reportGraph} id={"reportGraph"} />}
					</div>
				</div>
				<a style={{ position: "absolute", visibility: "hidden" }} tabIndex="-1" className="waves-effect waves-light btn modal-trigger" href="#showInputModal"></a>
			</section>
		);
	}
}

const map = state => {
	return {
		auth: state.auth.model
	};
};

const actions = {
	setAuthAction,
};

export default connect(map, actions)(Dashboard);


// WEBPACK FOOTER //
// src/containers/Dashboard.js